import { ArrowRight, LoaderCircle } from 'lucide-react'

import { Button, ButtonGroup } from 'slab'

type Props = {
  onBack?: () => void;
  onNext?: () => void;
  isNextDisabled?: boolean;
  isLoading?: boolean;
}

const LoadingIndicator = () => (
  <LoaderCircle className='animate-spin' />
)

export default function QuoteFlowButtonNav ({
  onBack,
  onNext,
  isNextDisabled,
  isLoading,
}: Props) {
  return (
    <div className='pb-10'>
      <ButtonGroup size='large'>
        {onBack && (
          <Button variant='secondary' onClick={onBack}>
            Back
          </Button>
        )}
        {onNext && (
          <Button
            variant='primary'
            leftIcon={isLoading ? LoadingIndicator : undefined}
            rightIcon={ArrowRight}
            onClick={onNext}
            disabled={isNextDisabled || isLoading}
          >
            Next
          </Button>
        )}
      </ButtonGroup>
    </div>
  )
}
